import React from 'react';
import { Helmet } from 'react-helmet';
import * as settings from '../../settings';

const defaultStrings = {
  title: 'Games, Videos, and Books for Kids',
  description:
    'FunBrain is the #1 site for online educational games for kids of all ages. (math, grammar, science, spelling, history)',
  keywords:
    'kids, fun, math, spell, history, logic, spelling, multiplication, game, children, baseball, learning, grammar, math, education, English, science, schools, libraries, fractions, parents, teachers',
};


const DocumentHeadFields = props => {
  const {
    mediaItem = {},
    mediaSeries = {},
    documentTitle,
    metaDescription,
    metaKeywords,
    location,
    pathname,
  } = props;

  let title =
    mediaItem.metaTitle ||
    mediaItem.title ||
    documentTitle ||
    defaultStrings.title;

  title = mediaSeries.title
    ? `${mediaSeries.title}: ${mediaItem.title}`
    : title;

  const metaTitle = mediaItem.type
    ? `${title} - a ${mediaItem.type} on Funbrain`
    : `${title} - Funbrain`;

  const description =
    mediaItem.metaDescription ||
    mediaItem.briefDescription ||
    metaDescription ||
    defaultStrings.description;

  const mediaKeywords = mediaItem.tags ? mediaItem.tags.join(',') : false;

  const keywords =
    mediaItem.metaKeywords ||
    mediaKeywords ||
    metaKeywords ||
    defaultStrings.keywords;

  const path = location ? location.pathname : pathname;
  const url = `${settings.CANONICAL_URL}${path}`;

  // The pathname is only passed in by the Express server.
  const encodeChars = pathname ? false : true;

  return (
    <Helmet encodeSpecialCharacters={encodeChars}>
      <title>{metaTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {mediaItem.imageURI ? (
        <meta property="og:image" content={mediaItem.imageURI} />
      ) : null}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default DocumentHeadFields;
